import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import React, { useCallback, useState } from 'react'
import SearchField from '../components/SearchField'
import ThemeEditor from './ThemeEditor'
import styled from 'styled-components'
import DataSettingsTreeView from './DataSettingsTreeView'
import { useDispatch, useSelector } from 'react-redux'
import TabOptions from './TabOptions'
import useLanguages from '../hooks/useLanguages'

const TabPanel = ({ children, className, value, index }) => {
  return (
    <div className={className} style={{ display: (value === index) ? 'flex' : 'none' }}>
      {children}
    </div>
  )
}

const StyledTabPanel = styled(TabPanel)`
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const TabsContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
`

const containerBoxStyle = { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }
const tabsContainerStyle = { borderBottom: 1, borderColor: 'divider' }

const CustomizationTabs = () => {
  const currentSite = useSelector(state => state.site)
  const dispatch = useDispatch()
  const [, languagesJson] = useLanguages()
  const [tabValue, setTabValue] = useState('data')

  const handleChangeTab = useCallback((event, newValue) => {
    setTabValue(newValue)
    dispatch({ type: 'selected-tab', data: newValue, })
    if (newValue.startsWith('data')) {
      dispatch({ type: 'select-language-data', data: newValue.startsWith('data-') ? newValue : false, })
    }
  }, [dispatch])

  return (
    <>
      {currentSite &&
        <Box className="tabs-container" sx={containerBoxStyle}>
          <TabsContainer sx={tabsContainerStyle}>
            <Tabs value={tabValue} onChange={handleChangeTab} aria-label="Customization options" variant="scrollable" scrollButtons="auto">
              <Tab label="Data" value='data' />
              {languagesJson?.map((lang) => (
                <Tab label={lang.language} key={lang.code} value={`data-${lang.code}`} />
              ))}
              <Tab label="General" value='general' />
              <Tab label="Theme" value='theme' />
              <Tab label="D-Sellers" value='dataSellers' />
              <Tab label="T-Sellers" value='themeSellers' />
            </Tabs>
            <TabOptions />
          </TabsContainer>
          <StyledTabPanel value={tabValue} index='data'>
            <SearchField />
            <DataSettingsTreeView dataToShow='data' />
          </StyledTabPanel>
          <StyledTabPanel value={tabValue} index='general'>
            <SearchField />
            <DataSettingsTreeView dataToShow='general' />
          </StyledTabPanel>
          {languagesJson?.map((lang) => (
            <StyledTabPanel value={tabValue} key={lang.code} index={`data-${lang.code}`}>
              <SearchField />
              <DataSettingsTreeView dataToShow='data' />
            </StyledTabPanel>
          ))}
          <StyledTabPanel value={tabValue} index='theme'>
            <ThemeEditor textName='theme.draft' />
          </StyledTabPanel>
          <StyledTabPanel value={tabValue} index='dataSellers'>
            <DataSettingsTreeView dataToShow='dataSellers' />
          </StyledTabPanel>
          <StyledTabPanel value={tabValue} index='themeSellers'>
            <ThemeEditor textName='themeSellers.draft' />
          </StyledTabPanel>
        </Box>
      }
    </>
  )
}

export default CustomizationTabs
